import Raven from 'lib/raven'
import { CRUSH_ACTIONS } from './crushes'

const SET_SCORES = 'crush/scores/SET_SCORES'
const SET_MODAL_VISIBILITY = 'crush/scores/SET_MODAL_VISIBILITY'

const initialState = {
  swipes: 0,
  rewinds: 0,
  showModal: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_SCORES:
      return {
        ...state,
        ...action.scores
      }

    case SET_MODAL_VISIBILITY:
      return {
        ...state,
        showModal: action.isVisible
      }

    default:
      return state
  }
}

export const setScores = scores => ({
  type: SET_SCORES,
  scores
})

export const setModalVisibility = isVisible => ({
  type: SET_MODAL_VISIBILITY,
  isVisible
})

export const receiveNewScores = (res, opts = {}) => (dispatch, getState) => {
  const scores = {
    swipes: res.scoreboardSwipes,
    rewinds: res.scoreboardRewinds
  }

  dispatch(setScores(scores))

  // Decide if login modal should be visible
  const { type } = opts
  const { swipes, rewinds } = getState().scores
  const { userLink } = getState().user.profile
  if (!userLink) {
    switch (type) {
      case CRUSH_ACTIONS.LIKE:
      case CRUSH_ACTIONS.DISLIKE:
        (swipes !== 0 && swipes % 80 === 0) && dispatch(setModalVisibility(true))
        break
      case CRUSH_ACTIONS.REVOKE:
        (rewinds % 3 === 0) && dispatch(setModalVisibility(true))
        break
      default:
        Raven.captureMessage(`Unknown score type ${type}`)
    }
  }

  return scores
}



// WEBPACK FOOTER //
// ./src/lib/store/scores.js